export default {

    data() {
        return {
            previewFiles: [],
            previewFileIndex: null
        }
    },

    methods: {
        showFilePreview(files, previewFile) {
            // this.previewFiles = files.filter(file => file.rerendering_percentage === null || file.rerendering_percentage >= 100);
            this.previewFiles = files.filter(file => file.state === 1 || file.state === 4/* 1 = ready, 4 = checking */);
            this.previewFileIndex = this.previewFiles.findIndex(file => file.id === previewFile.id);
        },

        addToPreviewIfNotExists(file) {
            if (file.state === 1 || file.state === 4/* 1 = ready, 4 = checking */) {
                if (this.previewFiles.findIndex(previewFile => previewFile.id === file.id) === -1) {
                    this.previewFiles.push(file)
                }
            }
        },

        clearFilePreview() {
            this.previewFiles = [];
            this.previewFileIndex = null;
        }
    }
}
